"use strict";

exports.__esModule = true;
exports.default = Header;
var _preact = require("preact");
var _User = _interopRequireDefault(require("./User.js"));
var _Breadcrumbs = _interopRequireDefault(require("../Breadcrumbs.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/destructuring-assignment */

function Header(props) {
  return (0, _preact.h)(_preact.Fragment, null, props.showBreadcrumbs && (0, _preact.h)(_Breadcrumbs.default, {
    getFolder: props.getFolder,
    breadcrumbs: props.breadcrumbs,
    breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
    title: props.title
  }), (0, _preact.h)(_User.default, {
    logout: props.logout,
    username: props.username,
    i18n: props.i18n
  }));
}